<template>
  <div class="c-quicklinks">
    <page-title>Links</page-title>
    <tabs v-if="tabs && tabs.length > 0">
      <tabs-item
        v-for="(tab, key) in tabs"
        :key="key"
        :active="tab.type === activeTab.type"
        @click="setActiveTab(tab)"
      >{{tab.title}}</tabs-item>
    </tabs>
    <section-block>
      <filter-bar showSearch resource="systems" action="listExternal" />
      <main v-if="!loading">
        <div v-if="activeTab.type == 'system'">
          <ol class="c-quicklinks__list c-quicklinks__list--system">
            <li v-for="system in externalSystems" :key="system.id" @click="gotoLink(system)">
              <div class="c-quicklinks__list__icon">
                <image-loader :image="system.icon" />
              </div>

              <div class="c-quicklinks__title">{{system.name}}</div>
            </li>
          </ol>
        </div>

        <div v-else>
          <ol class="c-quicklinks__list c-quicklinks__list--user">
            <li v-for="link in quickLinks" :key="link.id" @click="gotoLink(link)">
              <div class="c-quicklinks__list__icon">
                <icon name="link" :fill="false" />
              </div>

              <div class="c-quicklinks__title">{{link.name}}</div>
              <div><link-actions :row-data="{id:link.id}" /></div>
            </li>
            <li class="p-0">
              <base-button
                :primary="true"
                square
                type="button"
                block
                @click="addNewLink = true"
                iconBefore="link"
                :iconBeforeFill="false"
              >Add Quick Link</base-button>
            </li>
          </ol>
        </div>
        <modal v-if="addNewLink" class="ta-left" show-close-button @close="addNewLink = false">
          <h1 slot="header">Add Quick Link</h1>
          <form method="post" v-on:submit.prevent>
            <form-field full-width label="Title" name="name" type="text" v-model="newLink.name"></form-field>

            <form-field
              full-width
              label="Link"
              name="url"
              type="text"
              v-model="currentLink"
              :value="currentLink"
            ></form-field>

            <p>
              <label for="current_page">
                <input type="checkbox" id="current_page" @input="setCurrentLink" /> Use current page?
              </label>
            </p>

            <base-button type="submit" @click="onSubmit">Add Link</base-button>
          </form>
        </modal>
      </main>
      <loading v-else></loading>
    </section-block>
  </div>
</template>

<script>
import FilterBar from "@/components/FilterBar.vue";
import ImageLoader from "@/components/elements/ImageLoader.vue";
import LinkActions from "@/components/LinkActions";
import { mapState } from "vuex";
export default {
  name: "UserQuickLinks",

  components: {
    ImageLoader,
    LinkActions
  },

  methods: {
    setActiveTab(tab) {
      this.activeTab = tab;
    },
    setCurrentLink($e) {
      this.currentLink = "";
      if ($e.target.checked) {
        this.currentLink = this.$route.path;
      }
    },
    gotoLink(link) {
      const a = document.createElement("a");
      a.id = "generatedLink";
      a.href = link.url || link.link;
      a.target = "_blank";
      a.rel = "noopener nofollow external";
      a.click();
    },
    onSubmit() {
      this.newLink.url = this.currentLink;
      this.$store.dispatch("users/addQuickLink", this.newLink).then(resp => {
        this.$store.dispatch("users/getQuickLinks").then(resp => {
          this.addNewLink = false;
          //set an alert, close modal?
          this.$store.dispatch(
            "notifications/create",
            {
              body: `Your quick links have been updated`,
              type: "success"
            },
            { root: true }
          );
        });
      });
    }
  },

  data() {
    return {
      loading: true,
      type: "",
      activeTab: {},
      addNewLink: false,
      currentLink: "",
      newLink: {
        name: "",
        url: "",
        icon: "link"
      },
      tabs: [
        {
          type: "system",
          title: "System Links"
        },
        {
          type: "user",
          title: "Quick Links"
        }
      ]
    };
  },

  computed: {
    ...mapState("users", ["quickLinks"]),
    ...mapState("systems", ["externalSystems"]),
    selectedTab: {
      get() {
        return this.tabs[0];
      },
      set(newVal) {
        this.setActiveTab(newVal);
      }
    }
  },

  mounted() {
    this.$store.dispatch("systems/listExternal");
    this.$store.dispatch("users/getQuickLinks").then(resp => {
      this.loading = false;
      this.activeTab = this.tabs[0];
    });
  }
};
</script>

<style lang="scss" scoped>
.c-quicklinks {
  position: fixed;
  top: 70px;
  left: 0;
  width: 100vw;
  min-height: 100vh;
  background: #f1f4f5;
  z-index: 25;

  @media screen and (min-width: 1024px) {
    display: none;
  }

  &__title {
    flex: 10;
  }

  &__list {
    margin: 0;
    padding: 0;
    list-style-type: none;
    li {
      padding: 10px;
      display: flex;
      align-items: center;
      border-bottom: 1px solid #dcdfe2;
      cursor: pointer;

      @media (hover: hover) {
        transition: all ease-in-out 0.2s;
        &:hover {
          box-shadow: 0 0 20px rgba(0, 0, 0, 0.11);
        }
      }
    }

    &__icon {
      margin-right: 20px;
      max-width: 35px;
      max-height: 35px;
      img {
        border-radius: 100%;

        @supports (object-fit: cover) {
          min-height: 35px;
          width: 100%;
          min-width: 35px;
          height: 100%;
          object-fit: cover;
          max-width: 35px;
          max-height: 35px;
        }
      }
    }
  }
}
</style>